/*
 * Pete, PondLinersco's AI pond specialist.
 * Chat window (launcher bottom left) + "Questions about this product?" box under Add to cart on product pages.
 * The expert lives in the Cloudflare Worker shared with Hugo (Gym Flooring UK), Ted (Tarpaulins UK) and
 * Rory (Rubber Roof UK) and Stan (Stair Nosings UK); it picks Pete from the page's origin. Replies stream in and are read aloud
 * (British voice) unless the customer mutes. Customers can tap the big "Tap to talk to Pete" button and speak.
 * Snippet: snippets/pete.liquid (sets data-ai on #petePanel). Styles: assets/pete.css.
 */
(function () {
  'use strict';
  var panel = document.getElementById('petePanel');
  if (!panel || window.PeteChat) return;

  var AI_URL = panel.getAttribute('data-ai') || '';
  var BASE = AI_URL.replace(/\/chat\/?$/, '');
  var TTS_URL = BASE ? BASE + '/tts' : '';
  var STT_URL = BASE ? BASE + '/stt' : '';
  var PHONE = '01282 270214', TEL = 'tel:01282270214';
  var WA = 'https://wa.me/447822012977?text=' + encodeURIComponent('Hi, I need help choosing a pond liner');
  var EMAIL = 'sale@pondlinersco.co.uk';
  var TEAM = 'Call <a href="' + TEL + '">' + PHONE + '</a>, <a href="' + WA + '" target="_blank" rel="nofollow noopener">WhatsApp us</a> or email <a href="mailto:' + EMAIL + '">' + EMAIL + '</a> (Mon-Fri).';
  var STORE_KEY = 'pete_state_v1', VOICE_KEY = 'pete_voice_v1';

  var launch = document.getElementById('peteLaunch');
  var log = document.getElementById('peteLog');
  var chips = document.getElementById('peteChips');
  var form = document.getElementById('peteForm');
  var input = document.getElementById('peteInput');
  var statusEl = document.getElementById('peteStatus');
  var STATUS = 'AI pond specialist \u00B7 replies in seconds';

  var convo = [], history = [], busy = false;

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function money(pence) { return '\u00A3' + (pence / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function track(action, source) {
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'sn_specialist', sn_action: action, sn_source: source || 'unknown' }); } catch (e) {}
  }

  // ---------- Markdown-lite rendering ----------
  function renderMd(src) {
    var lines = esc(src).split('\n'), out = '', list = '';
    function closeList() { if (list) { out += '</' + list + '>'; list = ''; } }
    lines.forEach(function (ln) {
      var m;
      if ((m = ln.match(/^\s*[-\u2022*]\s+(.*)$/))) { if (list !== 'ul') { closeList(); out += '<ul>'; list = 'ul'; } out += '<li>' + m[1] + '</li>'; return; }
      if ((m = ln.match(/^\s*\d+[.)]\s+(.*)$/))) { if (list !== 'ol') { closeList(); out += '<ol>'; list = 'ol'; } out += '<li>' + m[1] + '</li>'; return; }
      closeList();
      if (ln.trim()) out += '<p>' + ln + '</p>';
    });
    closeList();
    return out.replace(/\*\*([^*]+)\*\*/g, '<b>$1</b>').replace(/\[([^\]]+)\]\(([^)\s]+)\)/g, function (all, t, u) {
      var href = u.replace(/&amp;/g, '&');
      var ok = /^\/(?!\/)/.test(href) || /^https:\/\/(www\.)?pondlinersco\.co\.uk\//.test(href) || /^tel:|^mailto:sale@pondlinersco\.co\.uk$|^https:\/\/wa\.me\/447822012977/.test(href);
      if (!ok) return t;
      var ext = /^https:\/\/wa\.me/.test(href);
      return '<a href="' + esc(href) + '"' + (ext ? ' target="_blank" rel="nofollow noopener"' : '') + '>' + t + '</a>';
    });
  }
  function visibleText(full) { return full.replace(/\[\[[^\]]*\]\]/g, '').replace(/\[\[[^\]]*$/, '').trim(); }

  // ---------- Product cards and quotes (filled in after the reply renders) ----------
  var productCache = {};
  function getProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
    }
    return productCache[handle];
  }
  function getVariants(ids) {
    if (!BASE || !ids.length) return Promise.resolve({});
    return fetch(BASE + '/variant?ids=' + ids.join(','), { mode: 'cors' })
      .then(function (r) { return r.ok ? r.json() : { variants: {} }; })
      .then(function (j) { return j.variants || {}; })
      .catch(function () { return {}; });
  }
  function imgUrl(src, w) {
    if (!src) return '';
    src = src.indexOf('//') === 0 ? 'https:' + src : src;
    return src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=' + w;
  }
  // Cut-to-size calculator listings are priced per centimetre: show no price on their cards.
  function cardHtml(p) {
    var calc = p.price_max > 0 && p.price_max < 600;
    var price = calc ? 'Cut to your size: enter the length on the page' : (p.price_min !== p.price_max ? 'From ' + money(p.price_min) : money(p.price_min));
    var img = p.featured_image ? '<img src="' + esc(imgUrl(p.featured_image, 160)) + '" alt="" width="64" height="64" loading="lazy">' : '<span class="pete-card__ph"></span>';
    return '<div class="pete-card">' + img + '<div class="pete-card__body"><div class="pete-card__name">' + esc(p.title) +
      '</div><div class="pete-card__price">' + price + '</div><a class="pete-card__link" href="/products/' + esc(p.handle) + '">View product</a></div></div>';
  }
  function quoteHtml(id, qty, v) {
    qty = Math.max(1, Math.min(999, parseInt(qty, 10) || 1));
    if (!v || v.price < 600) return ''; // never quote a per-centimetre calculator listing
    var opt = v.title && v.title !== 'Default Title' ? '<div><span>Option</span><b>' + esc(v.title) + '</b></div>' : '';
    var btn = v.available ? '<button type="button" class="pete-add" data-v="' + esc(id) + '" data-q="' + qty + '" data-h="' + esc(v.handle) + '">Add ' + qty + ' to basket</button>'
      : '<small>This option is currently unavailable online; please call us.</small>';
    return '<div class="pete-quote"><div><span>Product</span><b><a href="/products/' + esc(v.handle) + '?variant=' + esc(id) + '">' + esc(v.product) + '</a></b></div>' + opt +
      '<div><span>Quantity</span><b>' + qty + ' x ' + money(v.price) + '</b></div><div><span>Total</span><b>' + money(v.price * qty) + '</b></div>' +
      '<small>Inc. VAT. UK delivery \u00A39.99, 2 working days from dispatch.</small>' + btn + '</div>';
  }
  // Turns the reply's [[...]] tags into placeholders, returns chips + async fill job.
  function renderReply(text, holder) {
    var chipList = null, note = '', products = [], quotes = [];
    var body = text.replace(/\[\[(product|quote|chips|refusal|error)(?::([^\]]*))?\]\]/g, function (all, kind, arg) {
      arg = arg || '';
      if (kind === 'product') products.push(arg.trim());
      else if (kind === 'quote') { var b = arg.split(':'); if (/^\d+$/.test(b[0])) quotes.push({ id: b[0], q: b[1] }); }
      else if (kind === 'chips') chipList = arg.split('|').map(function (s) { return s.trim(); }).filter(Boolean).slice(0, 4);
      else note = "Sorry, I can't help with that one here. Our team can: " + TEAM;
      return '';
    });
    holder.innerHTML = renderMd(body.replace(/\[\[[^\]]*$/, '').trim()) + (note ? '<p>' + note + '</p>' : '') + '<div class="pete-extras"></div>';
    var extras = holder.querySelector('.pete-extras');
    var jobs = [];
    products.forEach(function (h) {
      var slot = document.createElement('div'); extras.appendChild(slot);
      jobs.push(getProduct(h).then(function (p) { slot.outerHTML = cardHtml(p); }).catch(function () { slot.remove(); }));
    });
    if (quotes.length) {
      var qslots = quotes.map(function () { var s = document.createElement('div'); extras.appendChild(s); return s; });
      jobs.push(getVariants(quotes.map(function (q) { return q.id; })).then(function (vs) {
        quotes.forEach(function (q, i) { var h = quoteHtml(q.id, q.q, vs[q.id]); if (h) qslots[i].outerHTML = h; else qslots[i].remove(); });
      }));
    }
    return { chips: chipList, done: Promise.all(jobs) };
  }

  // Some products need a cut length, width or insert colour entered on their own page (the theme's
  // cut-to-length block). Those can't go straight in the basket from the chat: open the product page
  // on the quoted variant instead, so the order is never missing a required detail.
  var needsPage = {};
  function pageNeedsDetails(handle) {
    if (!handle) return Promise.resolve(false);
    if (!(handle in needsPage)) {
      needsPage[handle] = fetch('/products/' + encodeURIComponent(handle), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) { return /data-custom-length/.test(html); })
        .catch(function () { return false; });
    }
    return needsPage[handle];
  }
  function addToCart(btn) {
    var id = +btn.getAttribute('data-v'), q = +btn.getAttribute('data-q'), h = btn.getAttribute('data-h');
    btn.disabled = true; btn.textContent = 'Adding...';
    pageNeedsDetails(h).then(function (needs) {
      if (needs) {
        btn.textContent = 'Opening the product to finish your options...';
        save(); track('quote_to_page', 'pete');
        window.location.href = '/products/' + encodeURIComponent(h) + '?variant=' + id;
        return;
      }
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: q }] }) })
        .then(function (r) { if (!r.ok) throw new Error(r.status); btn.textContent = 'Added, going to basket...'; save(); track('add_to_cart', 'pete'); window.location.href = '/cart'; });
    }).catch(function () { btn.disabled = false; btn.textContent = 'Try again'; });
  }

  // ---------- Speech: numbers and sizes the way a person says them ----------
  var ONES = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
  var TENS = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
  function words(n) {
    n = Math.floor(n);
    if (n < 20) return ONES[n];
    if (n < 100) return TENS[Math.floor(n / 10)] + (n % 10 ? '-' + ONES[n % 10] : '');
    if (n < 1000) return ONES[Math.floor(n / 100)] + ' hundred' + (n % 100 ? ' and ' + words(n % 100) : '');
    if (n < 1e6) { var r = n % 1000; return words(Math.floor(n / 1000)) + ' thousand' + (r ? (r < 100 ? ' and ' : ' ') + words(r) : ''); }
    return String(n);
  }
  function numWords(s) {
    s = String(s).replace(/,/g, '');
    var p = s.split('.'), w = words(parseInt(p[0], 10) || 0);
    if (p[1]) w += ' point ' + p[1].split('').map(function (d) { return ONES[+d]; }).join(' ');
    return w;
  }
  var UNIT = { mm: 'millimetres', cm: 'centimetres', m: 'metres', ft: 'feet', kg: 'kilos', gsm: 'g s m' };
  var NUM = '(\\d[\\d,]*(?:\\.\\d+)?)';
  function spoken(text) {
    var t = String(text).replace(/\[\[[^\]]*\]\]/g, ' ').replace(/\[([^\]]+)\]\([^)]+\)/g, '$1').replace(/\*\*/g, '').replace(/^\s*[-\u2022*]\s+/gm, '');
    t = t.replace(/\b0\d{3,4}[\s-]?\d{3}[\s-]?\d{3,4}\b/g, function (m) {
      return m.split(/[\s-]+/).map(function (g) { return g.split('').map(function (d) { return d === '0' ? 'oh' : ONES[+d]; }).join(' '); }).join(', ');
    });
    t = t.replace(/\u00A3(\d[\d,]*)(?:\.(\d\d))?/g, function (m, p, d) {
      var n = parseInt(p.replace(/,/g, ''), 10);
      return words(n) + (n === 1 ? ' pound' : ' pounds') + (d && d !== '00' ? ' ' + words(+d) : '');
    });
    t = t.replace(/\bLRV\b/g, 'L R V').replace(/\bPTV\b/g, 'P T V').replace(/\bLVT\b/g, 'L V T').replace(/\bGRP\b/g, 'G R P').replace(/\bDDA\b/g, 'D D A');
    t = t.replace(new RegExp(NUM + '\\s*m\u00B2', 'g'), function (m, n) { return numWords(n) + (parseFloat(n) === 1 ? ' square metre' : ' square metres'); });
    // 55 x 55mm, 2.7m x 3, 70x32mm
    t = t.replace(new RegExp(NUM + '\\s*(m|mm|cm)?\\s*[x\u00D7]\\s*' + NUM + '\\s*(m|mm|cm)?\\b', 'g'), function (m, a, ua, b, ub) {
      var u = ub || ua;
      return numWords(a) + ' by ' + numWords(b) + (u ? ' ' + UNIT[u] : '');
    });
    t = t.replace(new RegExp(NUM + '\\s*(mm|cm|kg|ft|m)\\b', 'g'), function (m, n, u) { return numWords(n) + ' ' + UNIT[u]; });
    t = t.replace(new RegExp(NUM + '\\s*%', 'g'), function (m, n) { return numWords(n) + ' percent'; });
    t = t.replace(new RegExp(NUM + '\\s*(?:-|\u2013)\\s*' + NUM, 'g'), function (m, a, b) { return numWords(a) + ' to ' + numWords(b); });
    t = t.replace(new RegExp(NUM, 'g'), function (m, n) { return numWords(n); });
    return t.replace(/\s+/g, ' ').trim();
  }
  function chunkText(text, max) {
    var parts = spoken(text).match(/[^.!?]+[.!?]*\s*/g) || [], out = [], cur = '';
    parts.forEach(function (p) { if ((cur + p).length > max && cur) { out.push(cur.trim()); cur = ''; } cur += p; });
    if (cur.trim()) out.push(cur.trim());
    return out;
  }

  // ---------- Voice out (Cloudflare TTS, British male voice; device voice as fallback) ----------
  var voiceOn = true, audioEl = null, playSeq = 0, audioUnlocked = false;
  var SILENT_WAV = 'data:audio/wav;base64,UklGRiQAAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQAAAAA=';
  try { voiceOn = localStorage.getItem(VOICE_KEY) !== '0'; } catch (e) {}
  function ensureAudio() { if (!audioEl) { audioEl = new Audio(); audioEl.preload = 'auto'; } return audioEl; }
  function unlockAudio() {
    if (audioUnlocked || !voiceOn || !TTS_URL) return;
    var a = ensureAudio(); a.src = SILENT_WAV;
    var p = a.play();
    if (p && p.then) p.then(function () { audioUnlocked = true; }, function () {}); else audioUnlocked = true;
  }
  function stopVoice() {
    playSeq++;
    if (audioEl && String(audioEl.src).indexOf('data:') !== 0) { try { audioEl.pause(); } catch (e) {} }
    if (window.speechSynthesis) window.speechSynthesis.cancel();
  }
  function speakDevice(text) {
    if (!window.speechSynthesis || !window.SpeechSynthesisUtterance) return;
    var synth = window.speechSynthesis, vs = synth.getVoices() || [];
    var gb = vs.filter(function (v) { return /en[-_]GB/i.test(v.lang); });
    var voice = gb.filter(function (v) { return /male|Ryan|Thomas|George|Daniel|Arthur|Oliver|Google UK English Male/i.test(v.name); })[0] || gb[0] || null;
    synth.cancel();
    chunkText(text, 220).forEach(function (c) {
      var u = new SpeechSynthesisUtterance(c); u.lang = 'en-GB'; if (voice) u.voice = voice; u.rate = 1.02; u.pitch = 0.95; synth.speak(u);
    });
  }
  function say(text) { if (!voiceOn || !text) return; stopVoice(); if (!TTS_URL) return speakDevice(text); var s = startStream(); s.feed(text, true); }
  // Speaks a reply while it streams: each finished sentence is queued and played in order.
  function startStream() {
    stopVoice();
    var seq = playSeq, a = ensureAudio(), queue = [], playing = false, taken = 0;
    function playNext() {
      if (seq !== playSeq) return;
      var src = queue.shift();
      if (!src) { playing = false; return; }
      playing = true;
      var moved = false;
      function advance() { if (!moved) { moved = true; playNext(); } }
      a.onended = advance; a.onerror = advance; a.src = src;
      var pr = a.play(); if (pr && pr.catch) pr.catch(advance);
    }
    function enqueue(chunk) {
      chunkText(chunk, 600).forEach(function (t) { if (t) queue.push(TTS_URL + '?t=' + encodeURIComponent(t)); });
      if (!playing) playNext();
    }
    return {
      feed: function (visible, final) {
        if (seq !== playSeq || !voiceOn) return;
        var rest = visible.slice(taken);
        if (!rest.trim()) return;
        var cut = 0;
        if (final) cut = rest.length;
        else {
          var min = taken === 0 ? 30 : 140, re = /[.!?:](?=\s)|\n/g, m;
          while ((m = re.exec(rest))) { var end = m.index + 1; if (end > 600) break; if (end >= min) { cut = end; if (taken === 0) break; } }
        }
        if (cut > 0) { enqueue(rest.slice(0, cut)); taken += cut; }
      }
    };
  }
  function setVoice(on, fromClick) {
    voiceOn = !!on;
    try { localStorage.setItem(VOICE_KEY, voiceOn ? '1' : '0'); } catch (e) {}
    [].forEach.call(document.querySelectorAll('[data-pete-voice]'), function (b) {
      b.setAttribute('aria-pressed', voiceOn ? 'true' : 'false');
      b.textContent = voiceOn ? 'Voice on' : 'Voice off';
      b.title = voiceOn ? 'Pete reads his answers out loud. Tap to mute' : "Tap to hear Pete's answers out loud";
    });
    if (!voiceOn) { stopVoice(); return; }
    if (fromClick) { audioUnlocked = false; unlockAudio(); say("Voice is on. Tell me about your pond and I'll talk you through it."); track('voice_on', fromClick); }
  }

  // ---------- Voice in (talk button -> /stt). Waits for real speech and a proper pause before sending. ----------
  var rec = null;
  function micSupported() { return !!(STT_URL && navigator.mediaDevices && navigator.mediaDevices.getUserMedia && window.MediaRecorder); }
  var MIC_SVG = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="9" y="2" width="6" height="12" rx="3"/><path d="M5 10a7 7 0 0 0 14 0M12 17v5M8 22h8"/></svg>';
  // The talk button: big and labelled, so nobody misses that they can just speak to Pete.
  function talkButton(hint) {
    if (!micSupported()) return '';
    return '<button type="button" class="pete-mic pete-talk" aria-label="Tap to talk to Pete">' +
      '<span class="pete-talk__ic">' + MIC_SVG + '</span><span class="pete-talk__txt">' +
      '<span class="pete-talk__idle"><b class="pete-talk__main">Tap to talk to Pete</b><span class="pete-talk__hint">' + hint + '</span></span>' +
      '<span class="pete-talk__rec"><b class="pete-talk__main">Listening\u2026 speak now</b><span class="pete-talk__hint">Pete sends it when you pause. Tap to stop.</span></span>' +
      '<span class="pete-talk__busy"><b class="pete-talk__main">Got it, one moment\u2026</b><span class="pete-talk__hint">Pete is working out your answer</span></span>' +
      '</span></button>';
  }
  function pickMime() {
    var c = ['audio/webm;codecs=opus', 'audio/webm', 'audio/mp4', 'audio/ogg;codecs=opus'];
    for (var i = 0; i < c.length; i++) if (MediaRecorder.isTypeSupported && MediaRecorder.isTypeSupported(c[i])) return c[i];
    return '';
  }
  function note(inp, msg) {
    var ph = inp.getAttribute('data-ph') || inp.placeholder;
    inp.setAttribute('data-ph', ph); inp.value = ''; inp.placeholder = msg;
    clearTimeout(inp._phT);
    if (msg !== ph) inp._phT = setTimeout(function () { inp.placeholder = ph; }, 5000);
  }
  function startMic(f) {
    var inp = f.querySelector('input'), btn = f.querySelector('.pete-mic');
    if (rec) { stopMic(); return; }
    stopVoice();
    navigator.mediaDevices.getUserMedia({ audio: { echoCancellation: true, noiseSuppression: true } }).then(function (stream) {
      var mime = pickMime(), mr = mime ? new MediaRecorder(stream, { mimeType: mime }) : new MediaRecorder(stream);
      rec = { mr: mr, stream: stream, chunks: [], form: f, input: inp, btn: btn };
      mr.ondataavailable = function (e) { if (e.data && e.data.size) rec.chunks.push(e.data); };
      mr.onstop = finishMic;
      mr.start();
      btn.classList.add('is-rec'); btn.setAttribute('aria-label', 'Stop listening');
      note(inp, 'Listening\u2026 just speak, then pause');
      try {
        var AC = window.AudioContext || window.webkitAudioContext, ac = new AC(), an = ac.createAnalyser();
        an.fftSize = 1024; ac.createMediaStreamSource(stream).connect(an); rec.ac = ac;
        var data = new Uint8Array(an.fftSize), heard = false, started = Date.now(), quietSince = started, voiced = 0, last = started;
        (function loop() {
          if (!rec || rec.mr !== mr) return;
          an.getByteTimeDomainData(data);
          for (var sum = 0, i = 0; i < data.length; i++) { var v = (data[i] - 128) / 128; sum += v * v; }
          var now = Date.now();
          if (Math.sqrt(sum / data.length) > 0.04) { voiced += now - last; quietSince = now; }
          last = now;
          if (voiced >= 250) heard = true;
          if (!heard && now - started > 10000) { rec.silent = true; stopMic(); return; }
          if ((heard && now - quietSince > 2200) || now - started > 30000) { stopMic(); return; }
          requestAnimationFrame(loop);
        })();
      } catch (e) { rec.timer = setTimeout(stopMic, 15000); }
    }).catch(function () { note(inp, 'Microphone blocked. Allow it in your browser, or type your question'); });
  }
  function stopMic() { if (rec) { try { if (rec.mr.state !== 'inactive') rec.mr.stop(); } catch (e) {} } }
  function finishMic() {
    var r = rec; rec = null; if (!r) return;
    r.stream.getTracks().forEach(function (t) { t.stop(); });
    if (r.ac) { try { r.ac.close(); } catch (e) {} }
    clearTimeout(r.timer);
    r.btn.classList.remove('is-rec'); r.btn.setAttribute('aria-label', 'Tap to talk to Pete');
    if (r.silent) { r.input.placeholder = r.input.getAttribute('data-ph') || r.input.placeholder; return; }
    r.btn.classList.add('is-busy'); note(r.input, 'Got it, one moment\u2026');
    var blob = new Blob(r.chunks, { type: r.mr.mimeType || 'audio/webm' });
    function done(text) {
      r.btn.classList.remove('is-busy');
      if (text === null) { note(r.input, "Sorry, I couldn't make that out. Could you type it?"); return; }
      if (!text) { note(r.input, "I didn't catch that. Tap to talk and try again"); return; }
      clearTimeout(r.input._phT); r.input.placeholder = r.input.getAttribute('data-ph') || r.input.placeholder; r.input.value = text;
      track('voice_ask', r.form.hasAttribute('data-pete-pdp') ? 'pdp' : 'chat');
      if (r.form.hasAttribute('data-pete-pdp')) pdpSubmit(r.form);
      else if (r.form.requestSubmit) r.form.requestSubmit(); else r.form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    }
    if (blob.size < 1000) { done(''); return; }
    fetch(STT_URL, { method: 'POST', headers: { 'Content-Type': blob.type || 'audio/webm' }, body: blob })
      .then(function (res) { if (!res.ok) throw new Error(res.status); return res.json(); })
      .then(function (j) { done((j && j.text) || ''); })
      .catch(function () { done(null); });
  }

  // ---------- Streaming a reply from the Worker ----------
  // opts: { messages, product, el (bubble) }
  function streamReply(opts) {
    var full = '', speech = voiceOn && TTS_URL ? startStream() : null;
    return fetch(AI_URL, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(opts.product ? { messages: opts.messages, product: opts.product } : { messages: opts.messages }) })
      .then(function (r) {
        if (!r.ok || !r.body) throw new Error('status ' + r.status);
        var reader = r.body.getReader(), dec = new TextDecoder();
        function pump() {
          return reader.read().then(function (res) {
            if (res.done) return;
            full += dec.decode(res.value, { stream: true });
            var vis = visibleText(full);
            if (vis) { opts.el.className = opts.el.className.replace(' pete-typing', ''); opts.el.innerHTML = renderMd(vis); if (speech) speech.feed(vis, false); }
            return pump();
          });
        }
        return pump();
      })
      .then(function () {
        if (!full.trim()) throw new Error('empty');
        if (speech) speech.feed(visibleText(full), true); else if (voiceOn) speakDevice(visibleText(full));
        return full;
      })
      .catch(function (e) { if (speech) stopVoice(); throw e; });
  }

  // ---------- Chat window ----------
  function paint(who, html) {
    var el = document.createElement('div');
    el.className = 'pete-msg pete-msg--' + who; el.innerHTML = html;
    log.appendChild(el); log.scrollTop = log.scrollHeight;
    return el;
  }
  function bot(html) { history.push({ who: 'bot', html: html }); return paint('bot', html); }
  function setChips(list) {
    chips.innerHTML = '';
    (list || []).forEach(function (c) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'pete-chip'; b.textContent = c;
      b.addEventListener('click', function () { ask(c); });
      chips.appendChild(b);
    });
    save();
  }
  function save() { try { sessionStorage.setItem(STORE_KEY, JSON.stringify({ c: convo.slice(-38), h: history.slice(-40), open: !panel.hidden })); } catch (e) {} }
  function restore() {
    try {
      var d = JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null');
      if (!d || !d.h || !d.h.length) return false;
      convo = d.c || []; history = d.h;
      history.forEach(function (m) { paint(m.who, m.html); });
      return d.open;
    } catch (e) { return false; }
  }
  function welcome() {
    bot("Hi, I'm Pete, PondLinersco's AI pond specialist. Tell me about your pond: roughly how long, wide and deep it is, and whether it's for fish, koi or wildlife, and I'll work out the right liner, size and kit for you.");
    setChips(['What size liner do I need?', 'EPDM or HDPE: which is best?', 'Best liner for a koi pond', 'Here are my pond sizes']);
    suggestFor('', function (qs) { if (!convo.length) setChips(qs); });
  }
  function ask(text) {
    text = String(text || '').trim();
    if (!text || busy) return;
    if (!AI_URL) { bot('Our chat is offline right now. ' + TEAM); return; }
    if (convo.length >= 38) { bot('This conversation is getting long. Tap restart to start a fresh one, or call the team on <a href="' + TEL + '">' + PHONE + '</a>.'); return; }
    busy = true; unlockAudio();
    var userHtml = esc(text); history.push({ who: 'user', html: userHtml }); paint('user', userHtml);
    chips.innerHTML = '';
    var sent = !convo.length && document.title ? '[Customer is on the page: ' + document.title.replace(/\s+/g, ' ').slice(0, 120) + ']\n' + text : text;
    var msgs = convo.concat([{ role: 'user', content: sent }]);
    var el = paint('bot', '<span class="pete-dots"><i></i><i></i><i></i></span>'); el.className += ' pete-typing';
    statusEl.textContent = 'Pete is typing\u2026';
    streamReply({ messages: msgs, el: el }).then(function (full) {
      var out = renderReply(full, el);
      convo = msgs.concat([{ role: 'assistant', content: full.trim() }]);
      out.done.then(function () { history.push({ who: 'bot', html: el.innerHTML }); save(); log.scrollTop = log.scrollHeight; });
      setChips(out.chips || []);
    }).catch(function () {
      el.innerHTML = "<p>Sorry, I couldn't get an answer just now. " + TEAM + '</p>';
    }).then(function () { busy = false; statusEl.textContent = STATUS; save(); });
  }
  function open(msg, source) {
    var wasHidden = panel.hidden;
    panel.hidden = false; launch.setAttribute('aria-expanded', 'true'); launch.classList.add('is-open');
    document.documentElement.classList.add('pete-is-open');
    requestAnimationFrame(function () { panel.classList.add('is-in'); });
    if (!log.children.length) welcome();
    if (wasHidden) track(msg ? 'ask' : 'open', source);
    if (window.matchMedia('(min-width: 750px)').matches) setTimeout(function () { input.focus(); }, 30);
    if (msg) ask(msg);
    save();
  }
  function close() {
    stopVoice(); if (rec) { rec.silent = true; stopMic(); }
    panel.classList.remove('is-in'); panel.hidden = true;
    launch.setAttribute('aria-expanded', 'false'); launch.classList.remove('is-open');
    document.documentElement.classList.remove('pete-is-open');
    save();
  }
  function reset() { stopVoice(); convo = []; history = []; log.innerHTML = ''; chips.innerHTML = ''; welcome(); save(); }

  // Suggested questions written by the Worker for this page (cached at the edge).
  function suggestFor(handle, cb) {
    if (!BASE) return;
    var key = 'pete_sg_' + (handle || '_home');
    try { var c = JSON.parse(sessionStorage.getItem(key) || 'null'); if (c && c.length) { cb(c); return; } } catch (e) {}
    fetch(BASE + '/suggest' + (handle ? '?product=' + encodeURIComponent(handle) : ''), { mode: 'cors' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var list = j && j.questions;
        if (!list || list.length < 3) return;
        try { sessionStorage.setItem(key, JSON.stringify(list)); } catch (e) {}
        cb(list);
      }).catch(function () {});
  }

  // ---------- "Questions about this product?" box on product pages ----------
  var PDP = null;
  function productHandle() { var m = location.pathname.match(/\/products\/([^/?#]+)/); return m ? decodeURIComponent(m[1]) : ''; }
  function pdpChip(q) { return '<button type="button" class="pete-e__chip" data-pete-ask="' + esc(q) + '">' + esc(q) + '</button>'; }
  function pdpSave() { try { sessionStorage.setItem('pete_pdp_v1_' + PDP.handle, JSON.stringify({ c: PDP.convo.slice(-30), h: PDP.thread.innerHTML, ch: PDP.chips.innerHTML })); } catch (e) {} }
  function pdpSubmit(f) {
    var inp = f.querySelector('input'), q = inp && inp.value.trim();
    if (!q) { if (inp) inp.focus(); return; }
    inp.value = ''; pdpAsk(q);
  }
  function pdpAsk(q) {
    if (!PDP || PDP.busy || !q) return;
    if (!AI_URL) { open(q, 'pdp'); return; }
    if (PDP.convo.length >= 38) { PDP.convo = []; PDP.thread.innerHTML = ''; }
    PDP.busy = true; unlockAudio(); track('ask', 'pdp-expert');
    var userEl = document.createElement('div'); userEl.className = 'pete-e__msg pete-e__msg--user'; userEl.innerHTML = esc(q); PDP.thread.appendChild(userEl);
    var el = document.createElement('div'); el.className = 'pete-e__msg pete-e__msg--bot pete-typing'; el.innerHTML = '<span class="pete-dots"><i></i><i></i><i></i></span>'; PDP.thread.appendChild(el);
    el.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    var msgs = PDP.convo.concat([{ role: 'user', content: q }]);
    streamReply({ messages: msgs, product: PDP.handle, el: el }).then(function (full) {
      var out = renderReply(full, el);
      PDP.convo = msgs.concat([{ role: 'assistant', content: full.trim() }]);
      if (out.chips && out.chips.length) PDP.chips.innerHTML = out.chips.map(pdpChip).join('');
      out.done.then(pdpSave);
    }).catch(function () {
      el.innerHTML = "<p>Sorry, I couldn't get an answer just now. " + TEAM + '</p>';
    }).then(function () { PDP.busy = false; });
  }
  function mountProductBox() {
    var handle = productHandle();
    if (!handle || document.querySelector('.pete-e--pdp')) return;
    // Dawn renders a hidden "installment" form before the real one, so prefer the add-to-cart form.
    var buy = document.querySelector('form[data-type="add-to-cart-form"]') ||
      document.querySelector('form[action*="/cart/add"]:not(.installment):not([data-pete-skip])');
    if (!buy) return;
    // Sit straight under the buy buttons, outside the theme's <product-form> so the box's input and
    // buttons never reach the cart code.
    var anchor = buy.closest('product-form') || buy;
    var box = document.createElement('section');
    box.className = 'pete-e pete-e--pdp';
    var talk = talkButton('Just ask out loud. Pete answers you back.');
    box.innerHTML = '<div class="pete-e__head"><span class="pete-e__icon" aria-hidden="true">P</span><div><div class="pete-e__title">Questions about this product?</div>' +
      '<div class="pete-e__sub">' + (talk ? 'Talk or type to Pete' : 'Ask Pete') + ', our AI pond specialist. Answers in seconds, with the right size, fit and price for your pond.</div></div>' +
      '<button type="button" class="pete-e__voice" data-pete-voice aria-pressed="true">Voice on</button></div>' +
      '<div class="pete-e__thread" aria-live="polite"></div>' +
      '<div class="pete-e__form' + (talk ? ' has-talk' : '') + '" data-pete-pdp>' + talk +
      '<input type="text" enterkeyhint="send" maxlength="1000" placeholder="Ask anything about this product\u2026" aria-label="Ask a question about this product">' +
      '<button type="button" class="pete-e__send" data-pete-pdp-send>Ask</button></div>' +
      '<div class="pete-e__chips">' + ['Will this suit my pond?', 'What size do I need?', 'Is it safe for fish?'].map(pdpChip).join('') + '</div>';
    anchor.parentNode.insertBefore(box, anchor.nextSibling);
    PDP = { box: box, handle: handle, thread: box.querySelector('.pete-e__thread'), chips: box.querySelector('.pete-e__chips'), convo: [], busy: false };
    try {
      var d = JSON.parse(sessionStorage.getItem('pete_pdp_v1_' + handle) || 'null');
      if (d && d.c) { PDP.convo = d.c; PDP.thread.innerHTML = d.h || ''; if (d.ch) PDP.chips.innerHTML = d.ch; }
    } catch (e) {}
    if (!PDP.convo.length) suggestFor(handle, function (qs) { if (!PDP.convo.length) PDP.chips.innerHTML = qs.map(pdpChip).join(''); });
  }

  // ---------- Wiring ----------
  function init() {
    var mic = document.getElementById('peteMicSlot');
    if (mic) mic.outerHTML = talkButton("Just tell Pete about your pond. He answers out loud.");
    if (form.querySelector('.pete-talk')) form.classList.add('has-talk');
    launch.hidden = false;
    launch.addEventListener('click', function () { panel.hidden ? open(null, 'launcher') : close(); });
    document.getElementById('peteClose').addEventListener('click', close);
    document.getElementById('peteRestart').addEventListener('click', reset);
    form.addEventListener('submit', function (e) { e.preventDefault(); var q = input.value.trim(); if (!q) { input.focus(); return; } input.value = ''; ask(q); });
    document.addEventListener('click', function (e) {
      var vb = e.target.closest('[data-pete-voice]');
      if (vb) { e.preventDefault(); setVoice(!voiceOn, vb.closest('.pete-e') ? 'pdp' : 'chat'); return; }
      var m = e.target.closest('.pete-mic');
      if (m) { e.preventDefault(); var f = m.closest('form, [data-pete-pdp]'); if (f && !m.classList.contains('is-busy')) { unlockAudio(); startMic(f); } return; }
      var c = e.target.closest('[data-pete-ask]');
      if (c) { e.preventDefault(); pdpAsk(c.getAttribute('data-pete-ask')); return; }
      var send = e.target.closest('[data-pete-pdp-send]');
      if (send) { e.preventDefault(); pdpSubmit(send.closest('[data-pete-pdp]')); return; }
      var add = e.target.closest('.pete-add');
      if (add) { e.preventDefault(); addToCart(add); return; }
      var opener = e.target.closest('[data-pete-open]');
      if (opener) { e.preventDefault(); open(opener.getAttribute('data-pete-open') || null, 'link'); return; }
      // On phones the chat fills the screen, so a page link inside it (View product, a quote link) must
      // close the chat first; otherwise it restores open on the next page and hides what was tapped.
      var link = e.target.closest('#petePanel a[href]');
      if (link && !panel.hidden && link.target !== '_blank' && /^https?:$/.test(link.protocol) && link.hostname === location.hostname && window.matchMedia('(max-width: 749px)').matches) close();
    });
    // The product box has no form of its own, so Enter is handled here and never reaches the theme's
    // product form (where it would add to basket).
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || e.isComposing) return;
      var f = e.target.closest && e.target.closest('[data-pete-pdp]');
      if (f) { e.preventDefault(); e.stopPropagation(); pdpSubmit(f); }
    }, true);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) close(); });
    if (restore()) open(null, 'restore');
    mountProductBox();
    setVoice(voiceOn, false);
    window.PeteChat = {
      open: function (q, source) { open(q || null, source || 'api'); },
      close: close,
      toggle: function () { panel.hidden ? open(null, 'api') : close(); },
      // Opens the chat and starts listening straight away (the header search mic). Must run inside a click.
      talk: function (source) {
        open(null, source || 'talk');
        var m = form.querySelector('.pete-mic');
        if (m && !rec && navigator.mediaDevices) { unlockAudio(); startMic(form); }
        else setTimeout(function () { input.focus(); }, 30);
      }
    };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
